const defaultConfiguration = {
  widgets: [
    'notificationWidget',
    'ordersWidget',
    'academywidget',
    'comSchoolWidget',
    'researchWidget'
  ]
}

export default {
  state: defaultConfiguration
}
